// Localized category name/description. Base fields are EN; NL/FR fall back to base.
export function categoryName(cat, lang) {
  if (!cat) return "";
  if (lang === "nl" && cat.name_nl && cat.name_nl.trim()) return cat.name_nl;
  if (lang === "fr" && cat.name_fr && cat.name_fr.trim()) return cat.name_fr;
  if (lang === "de" && cat.name_de && cat.name_de.trim()) return cat.name_de;
  return cat.name;
}

export function categoryDesc(cat, lang) {
  if (!cat) return "";
  if (lang === "nl" && cat.description_nl && cat.description_nl.trim()) return cat.description_nl;
  if (lang === "fr" && cat.description_fr && cat.description_fr.trim()) return cat.description_fr;
  if (lang === "de" && cat.description_de && cat.description_de.trim()) return cat.description_de;
  return cat.description || "";
}

export function findCategory(cats, base) {
  return (cats || []).find((c) => c.name === base) || null;
}

// Localized label for a product's stored category base name.
export function localizeCategory(cats, base, lang) {
  const c = findCategory(cats, base);
  return c ? categoryName(c, lang) : base;
}
